import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ImportOfflineCardsToStockMutationVariables = Types.Exact<{
  cards: Array<Types.OfflineCardImportInput> | Types.OfflineCardImportInput;
}>;


export type ImportOfflineCardsToStockMutation = { __typename?: 'Mutation', importOfflineCardsToStock: Array<{ __typename?: 'OfflineCard', user_id: string, signup_code: string, trackable_item_id: string }> };


export const ImportOfflineCardsToStockDocument = gql`
    mutation ImportOfflineCardsToStock($cards: [OfflineCardImportInput!]!) {
  importOfflineCardsToStock(cards: $cards) {
    user_id
    signup_code
    trackable_item_id
  }
}
    `;
export type ImportOfflineCardsToStockMutationFn = Apollo.MutationFunction<ImportOfflineCardsToStockMutation, ImportOfflineCardsToStockMutationVariables>;

/**
 * __useImportOfflineCardsToStockMutation__
 *
 * To run a mutation, you first call `useImportOfflineCardsToStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportOfflineCardsToStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importOfflineCardsToStockMutation, { data, loading, error }] = useImportOfflineCardsToStockMutation({
 *   variables: {
 *      cards: // value for 'cards'
 *   },
 * });
 */
export function useImportOfflineCardsToStockMutation(baseOptions?: Apollo.MutationHookOptions<ImportOfflineCardsToStockMutation, ImportOfflineCardsToStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportOfflineCardsToStockMutation, ImportOfflineCardsToStockMutationVariables>(ImportOfflineCardsToStockDocument, options);
      }
export type ImportOfflineCardsToStockMutationHookResult = ReturnType<typeof useImportOfflineCardsToStockMutation>;
export type ImportOfflineCardsToStockMutationResult = Apollo.MutationResult<ImportOfflineCardsToStockMutation>;
export type ImportOfflineCardsToStockMutationOptions = Apollo.BaseMutationOptions<ImportOfflineCardsToStockMutation, ImportOfflineCardsToStockMutationVariables>;